import React from "react";
import { Card } from "../../../CommonElements/Hajj/Card";
import { Stack } from "react-bootstrap";
import { LabelValue } from "../../../CommonElements/LableValue/LabelValue";
import { useTranslation } from "react-i18next";
import { useLocalizedText } from "../../../utils/hooks/useLocalizedText";

// Skeleton components
export const JobDataSkeleton = () => {
  const { t } = useTranslation();

  return (
    <Card header={<div className="skeleton skeleton-section-header"></div>}>
      <Stack gap={3}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Stack key={index}>
            <div className="skeleton skeleton-job-label"></div>
            <div className="skeleton skeleton-job-value"></div>
          </Stack>
        ))}
      </Stack>
    </Card>
  );
};

export const PermissionsDataSkeleton = () => {
  const { t } = useTranslation();

  return (
    <Card header={<div className="skeleton skeleton-section-header"></div>}>
      <Stack gap={3}>
        <Stack>
          <div className="skeleton skeleton-permission-label"></div>
          <div className="skeleton skeleton-permission-value-long"></div>
        </Stack>
        <Stack>
          <div className="skeleton skeleton-permission-label"></div>
          <div className="skeleton skeleton-permission-value-short"></div>
        </Stack>
      </Stack>
    </Card>
  );
};

export const JobData = (props) => {
  const { data } = props;
  const { job, sector, department, job_destination, service_center } = data;
  const { t } = useTranslation();
  const { getLocalizedText } = useLocalizedText();
  

  return (
    <Card header={<span className="H5">{t("JOB_DATA")}</span>}>
      <Stack gap={3}>
        <Stack>
          <LabelValue
            label={t("JOB_TITLE")}
            value={getLocalizedText(job?.name_ar, job?.name_en)}
            direction="vertical"
          />
        </Stack>
        <Stack>
          <LabelValue
            label={t("EMPLOYER")}
            value={getLocalizedText(job_destination?.name_ar, job_destination?.name_en)}
            direction="vertical"
          />
        </Stack>
        <Stack>
          <LabelValue
            label={t("SECTOR")}
            value={getLocalizedText(sector?.name_ar, sector?.name_en)}
            direction="vertical"
          />
        </Stack>
        <Stack>
          <LabelValue
            label={t("DEPARTMENT")}
            value={getLocalizedText(department?.name_ar, department?.name_en)}
            direction="vertical"
          />
        </Stack>
        <Stack>
          <LabelValue
            label={t("SERVICE_CENTER")}
            value={getLocalizedText(service_center?.name_ar, service_center?.name_en)}
            direction="vertical"
          />
        </Stack>
      </Stack>
    </Card>
  );
};

export const PermissionsData = (props) => {
  const { data } = props;
  const { systems, groups } = data;
  const { t } = useTranslation();
  const { getLocalizedText } = useLocalizedText();
  const hasPermissions = !!systems.length;
  const hasGroups = !!groups.length;

  return (
    <Card header={<span className="H5">{t("PERMISSIONS_DATA")}</span>}>
      <Stack gap={3}>
        <LabelValue
          label={t("PLATFORM_PERMISSIONS")}
          value={
            hasPermissions
              ? systems.map((system) => getLocalizedText(system?.name_ar, system?.name_en)).join(" - ")
              : t("NO_PERMISSIONS")
          }
          direction="vertical"
        />

        <LabelValue
          label={t("USER_GROUP")}
          value={
            hasGroups
              ? groups.map((group) => getLocalizedText(group?.name_ar, group?.name_en)).join(" - ")
              : t("NO_GROUPS")
          }
          direction="vertical"
        />
      </Stack>
    </Card>
  );
};
